import React, { PureComponent } from 'react'
import Helmet from 'next/head'
import PropTypes from 'prop-types'
import { Constants, OrganizationConstants } from '../../adapters/helpers/Constants'
import DOMPurify from 'isomorphic-dompurify'

class OrganizationSEO extends PureComponent {
    constructor(props) {
        super(props)
    }

    static propTypes = {
        name: PropTypes.string,
        description: PropTypes.string,
        brandLogoUrl: PropTypes.string,
        pagePath: PropTypes.string,
    }

    render() {
        const { name, description, brandLogoUrl, pagePath } = this.props
        const BASE_URL = process.env.BASE_URL
        
        if (!name || !description) {
            return null
        }
        
        return (
            <Helmet>
                <script
                    type={Constants.typeLD}
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(JSON.stringify({
                            "@context": Constants.context,
                            "@type": Constants.organization,
                            "name": name,
                            "alternateName": Constants.brand,
                            "url": BASE_URL || pagePath,
                            "logo": brandLogoUrl,
                            "description": description,
                            "sameAs": [
                                "https://www.facebook.com/OralBIndia",
                                "https://www.instagram.com/oralbindia",
                                "https://twitter.com/oralb",
                                "https://www.youtube.com/oralb"
                            ],
                            "brand": {
                                "@type": "Brand",
                                "name": Constants.brand
                            },
                            "parentOrganization": {
                                "@type": Constants.organization,
                                "name": OrganizationConstants.parentOrganization,
                                "url": OrganizationConstants.parentOrganizationUrl
                            }
                        })),
                    }}
                />
            </Helmet>
        )
    }
}
export default OrganizationSEO
